var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SavCoForm',{attrs:{"form":_vm.form,"lottie":_vm.lottie},on:{"complete":_vm.complete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }